import { RSAA } from 'redux-api-middleware';

export const FETCH_CONTENT = 'FETCH_CONTENT';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILED = 'FETCH_CONTENT_FAILED';
export const fetchContent = (contentPath = './business-accounts.content.json') => ({
  [RSAA]: {
    endpoint: contentPath,
    method: 'GET',
    types: [
      {
        type: FETCH_CONTENT,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_CONTENT_SUCCESS,
        meta: {
          loading: false
        }
      },
      {
        type: FETCH_CONTENT_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});
